<template>
  <div>
    <van-empty
      class="custom-image"
      :image="require('@/assets/result-empty.png')"
      :description="tag == true ? '暂无数据排名' : '暂无成绩排名'"
    />
  </div>
</template>
<script>
export default {
  props: {
    tag: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-image {
  padding-top: 120px;
  .van-empty__image {
    width: 152px;
    height: 128px;
  }
  ::v-deep .van-empty__description {
    margin-top: 20px;
    line-height: 20px;
    color: $gray-color;
  }
}
</style>
